import { render } from "./ViewDataTables.vue?vue&type=template&id=429e67c7&scoped=true"
import script from "./ViewDataTables.vue?vue&type=script&lang=js"
export * from "./ViewDataTables.vue?vue&type=script&lang=js"

import "./ViewDataTables.vue?vue&type=style&index=0&id=429e67c7&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-429e67c7"]])

export default __exports__